import React, { Component } from 'react';
import { Translate } from '$common';



export default class TagList extends Component {
  static type = 'tag';
  static optionable = true;
  static elementName = Translate.get('tag_list');
  static icon = 'plus-square-o';

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/task-form/question-types/tag-list.js